import React, { useRef } from "react";
import { View, StyleSheet, TouchableOpacity, Animated, Easing } from "react-native";
import config from "../config/config";
import AppText from "./AppText";
import ImageCarousel from "./ImageCarousel";
import Icon from "./Icon";
import { callNumber, sendWhatsapp } from "../utility/contactUser";
import IconTouchable from "./IconTouchable";

function ListingCard({ product, navigation }) {
    const glowValue = useRef(new Animated.Value(0)).current;
    const springValue = useRef(new Animated.Value(1)).current;

    const spring = () => {
        glowValue.setValue(0);
        Animated.timing(glowValue, {
            toValue: 2,
            duration: 400,
            useNativeDriver: false,
        }).start(() => navigation.navigate("ProductDetails", product));

        springValue.setValue(0.9);
        Animated.spring(springValue, {
            toValue: 1,
            friction: 4,
            useNativeDriver: false,
        }).start();
    };

    return (
        <Animated.View
            style={{
                overflow: "hidden",
                borderRadius: 20,
                backgroundColor: config.colors.tertiary,
                borderColor: glowValue.interpolate({
                    inputRange: [0, 0.1, 2],
                    outputRange: [config.colors.primary, config.colors.green, config.colors.primary],
                }),
                borderWidth: 5,
                margin: 10,
                flex: 1,
                transform: [{ scale: springValue }],
            }}
        >
            <TouchableOpacity onPress={() => spring()}>
                <View
                    style={{
                        position: "absolute",
                        right: -2,
                        top: -2,
                        zIndex: 1,
                        backgroundColor: config.colors.tertiary,
                        borderTopRightRadius: 20,
                        borderBottomLeftRadius: 20,
                        padding: 5,
                        paddingRight: 20,
                        borderWidth: 2,
                        borderColor: config.colors.primary,
                    }}
                >
                    <View style={{ flexDirection: "row" }}>
                        <Icon name="cash" />
                        <View>
                            <AppText style={styles.title}>Price</AppText>
                            <AppText style={styles.subTitle}>£{product.price}</AppText>
                        </View>
                    </View>
                </View>
                <ImageCarousel imageData={product.images} enableUpload={false} navigation={navigation} />
                <View style={{ backgroundColor: config.colors.primary, height: 2 }}></View>
                <View style={styles.cardBody}>
                    <View style={{ flexDirection: "row", marginTop: 10 }}>
                        <Icon name="card-text-outline" />
                        <View>
                            <AppText style={styles.title}>Product Description </AppText>
                            <AppText numberOfLines={3} style={styles.subTitle}>
                                {product.description}
                            </AppText>
                            <AppText style={styles.subTitle}>{product?.vehicle?.make && product.vehicle.make}</AppText>
                            <AppText style={styles.subTitle}>{product?.vehicle?.model && product.vehicle.model}</AppText>
                            <AppText style={styles.subTitle}>{product?.vehicle?.year && product.vehicle.year}</AppText>
                        </View>
                    </View>
                    <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
                        <View>
                            <View style={{ flexDirection: "row", marginTop: 10 }}>
                                <Icon name="engine" />
                                <View>
                                    <AppText style={styles.title}>Engine</AppText>
                                    <AppText style={styles.subTitle}>Code: {product?.vehicle?.engineCode} </AppText>
                                    <AppText style={styles.subTitle}>Size: {product?.vehicle?.engineSize} </AppText>
                                    <AppText style={styles.subTitle}>TType: {product?.vehicle?.transmissionType} </AppText>
                                </View>
                            </View>
                        </View>
                        <View style={{ flexDirection: "row", marginTop: 10 }}>
                            <View>
                                <AppText style={styles.title}>Category </AppText>
                                <AppText style={styles.subTitle}>{product.category} </AppText>
                            </View>
                            <Icon name="shape" />
                        </View>
                    </View>
                </View>
            </TouchableOpacity>
            <View style={{ flexDirection: "row", justifyContent: "space-evenly", paddingBottom: 10 }}>
                <IconTouchable
                    name="phone"
                    onPress={async () => {
                        callNumber({ phone: "07398616294" });
                    }}
                    backgroundColor={config.colors.danger}
                    size={40}
                    text={"Contact Sales"}
                />
                <IconTouchable
                    name="whatsapp"
                    onPress={async () => {
                        sendWhatsapp({ phone: "07398616294" }, product.description + "\nCategory: " + product.category.name);
                    }}
                    backgroundColor={config.colors.danger}
                    size={40}
                    text={"Contact Sales"}
                />
            </View>
        </Animated.View>
    );
}

const styles = StyleSheet.create({
    title: {
        fontSize: 14,
        fontWeight: "800",
        color: config.colors.white,
    },
    price: {
        fontSize: 14,
        fontWeight: "800",
        color: config.colors.danger,
    },
    subTitle: {
        fontSize: 14,
        fontWeight: "800",
        color: config.colors.primary,
    },
    card: {
        backgroundColor: config.colors.tertiary,
        overflow: "hidden",
        borderRadius: 20,
        borderColor: config.colors.primary,
        borderWidth: 2,
        margin: 10,
        flex: 1,
    },
    cardBody: {
        justifyContent: "space-between",
        marginHorizontal: 5,
        marginBottom: 10,
    },
    header: {
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
    },
    footer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
    },
    statusBarText: {
        fontWeight: "700",
        fontSize: 18,
        textTransform: "capitalize",
        color: config.colors.black,
    },
    buttonText: {
        fontWeight: "700",
        fontSize: 18,
        textTransform: "capitalize",
        color: config.colors.black,
    },
    buttonContainer: {
        flexDirection: "row",
        flex: 1,
        paddingBottom: 10,
        paddingHorizontal: 10,
    },
    buttonLeft: {
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 20,
        borderColor: config.colors.tertiary,
        backgroundColor: config.colors.primary,
        flex: 1,
        marginRight: 5,
    },
    buttonRight: {
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 20,
        backgroundColor: config.colors.primary,
        borderColor: config.colors.tertiary,
        flex: 1,
        marginLeft: 5,
    },
    buttonCenter: {
        justifyContent: "center",
        alignItems: "center",
        borderRadius: 20,
        backgroundColor: config.colors.danger,
        borderColor: config.colors.tertiary,
        flex: 1,
    },
    logo: {
        flex: 1,
    },
});

export default ListingCard;
